<template>
  <div class="lawsDetail">
    <div class="lawsDetail_" v-bind:style="{ minHeight: Height + 'px' }">
      <div
        style="min-width: 1200px; margin: auto; display: flex"
        :style="
          detailAll.mulu && detailAll.mulu.length !== 0
            ? 'width: 860px;'
            : 'width:1080px'
        "
      >
        <!-- display: flex -->
        <div
          :class="upOrmu ? 'catalog' : 'catalogCopy'"
          v-if="detailAll.mulu && detailAll.mulu.length > 0"
        >
          <!-- :style="'margin-top:' + pageheight + 'px;'" -->
          <div
            v-if="detailAll.mulu.length !== 0"
            class="directory"
            :style="upOrmu ? '' : 'height:50px;'"
          >
            <div class="tit" style="font-family: '思源黑体CN'">
              <span style="font-size: 20px">目录</span
              ><span style="font-size: 20px" v-if="upOrmu" @click="packUpmu"
                ><i class="el-icon-arrow-up"></i
              ></span>
              <span v-if="!upOrmu" style="font-size: 20px" @click="packUpmu"
                ><i class="el-icon-arrow-down"></i
              ></span>
            </div>
            <div class="catalog01" v-if="upOrmu">
              <ul>
                <li
                  v-for="(item, index) in detailAll.mulu"
                  :key="index"
                  style="margin: 10px 0"
                >
                  <!-- <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.name"
                  placement="right"
                > -->
                  <span
                    @click="jump(item, index)"
                    :style="
                      muluOne == index ? 'color: #E6A23C;font-weight: 600;' : ''
                    "
                    >{{ item.name }}</span
                  >
                  <!-- </el-tooltip> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box00">
          <div v-if="detailAll.mulu">
            <div
              class="box"
              :style="detailAll.mulu.length !== 0 ? 'margin: 0 0 0 200px;' : ''"
              ref="backTop"
              id="top"
            >
              <div class="detail">
                <div class="breadcrumb">
                  <el-breadcrumb separator-class="el-icon-arrow-right" style="display: flex;font-size:16px;">
                    <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
                    <el-breadcrumb-item :to="{ path: '/lawsStatute' }"
                      >法律法规</el-breadcrumb-item
                    >
                    <el-breadcrumb-item
                      ><span
                        style="
                          display: inline-block;
                          max-width: 700px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        {{ detailAll.Title }}</span
                      ></el-breadcrumb-item
                    >
                  </el-breadcrumb>
                </div>
                <div class="title" id="item000">
                  <div style="display: flex; align-items: center; width: 100%">
                    <h1 style="font-family: '思源黑体CN'">
                      {{ detailAll.Title }}
                    </h1>
                    <!-- <p><span>推荐时间：2018-05-29</span><span>推荐人：罗奎</span></p> -->
                  </div>
                  <div class="operates">
                    <div class="collection" v-if="!detailAll.coll">
                      <el-tooltip
                        content="收藏"
                        placement="bottom"
                        effect="light"
                      >
                        <img
                          @click="collectible(detailAll00)"
                          src="../../../../assets/imgs/2.0/_收藏.png"
                          alt=""
                        />
                      </el-tooltip>
                    </div>
                    <div class="collection" v-if="detailAll.coll">
                      <el-tooltip content="收藏" placement="top" effect="light">
                        <img
                          v-if="detailAll.coll == 0"
                          @click="collectible(detailAll00)"
                          src="../../../../assets/imgs/2.0/_收藏.png"
                          alt=""
                        />
                      </el-tooltip>
                      <el-popconfirm
                        title="确认取消收藏吗？"
                        @confirm="cancel(detailAll00)"
                      >
                        <img
                          slot="reference"
                          v-if="detailAll.coll == 1"
                          src="../../../../assets/imgs/2.0/收藏3.png"
                          alt=""
                        />
                      </el-popconfirm>
                    </div>
                    <el-dropdown style="height: 28px; margin: 0px 20px">
                      <!-- <el-button type="primary" size="mini" style="height: 28px"
                    >下载</el-button
                  > -->
                      <el-button
                        type="warning"
                        icon="el-icon-download"
                        circle
                        size="mini"
                      ></el-button>
                      <!-- <i class="el-icon-download"></i> -->
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          ><span @click="down(parameter.id, 'pdf')"
                            ><img
                              class="down_icon"
                              src="../../../../assets/imgs/图标/pdf (1).png"
                              alt=""
                            />
                            PDF文件</span
                          ></el-dropdown-item
                        >
                        <el-dropdown-item
                          ><span @click="down(parameter.id, 'word')"
                            ><img
                              class="down_icon"
                              src="../../../../assets/imgs/图标/word.png"
                              alt=""
                            />
                            WORD文件</span
                          ></el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>

                <div class="box_botton">
                  <div class="box_body" ref="backTop" id="top">
                    <div
                      class="txt"
                      id="item00"
                      v-if="
                        detailAll.type == '中央法规' ||
                        detailAll.type == '地方法规'
                      "
                    >
                      <h2>基本信息</h2>
                      <div class="content01">
                        <div class="field_line">
                          <span class="header">发布部门：</span>

                          <span class="con" v-if="detailAll.Pub_Department"
                            ><span
                              v-for="(item, index) in detailAll.Pub_Department"
                              :key="index"
                              >{{
                                item.names[item.names.length - 1]
                              }}&ensp;&ensp;
                            </span></span
                          >
                        </div>
                        <div class="field_line">
                          <span class="header"> 发文字号：</span
                          ><span class="con">{{ detailAll.Iss_Num }}</span>
                        </div>
                        <div class="field">
                          <span class="header">发布日期：</span
                          ><span class="con">{{ detailAll.Pub_Time }}</span>
                        </div>
                        <div class="field">
                          <span class="header"> 实施日期：</span
                          ><span class="con">{{ detailAll.Pub_Time }}</span>
                        </div>
                        <div class="field">
                          <span class="header"> 时&ensp;效&ensp;性：</span
                          ><span class="con">{{ detailAll.Timeliness }}</span>
                        </div>
                        <div class="field">
                          <span class="header">失效依据：</span
                          ><span class="con">{{
                            detailAll.Failure_Basis
                          }}</span>
                        </div>
                        <div class="field">
                          <span class="header">专题类型：</span
                          ><span class="con" v-if="detailAll.Thematic_Class"
                            ><span>{{
                              detailAll.Thematic_Class[0].names[
                                detailAll.Thematic_Class[0].names.length - 1
                              ]
                            }}</span></span
                          >
                        </div>
                        <div class="field">
                          <span class="header">效力级别：</span
                          ><span class="con" v-if="detailAll.Eff_Level"
                            ><span
                              >{{
                                detailAll.Eff_Level[0].names[
                                  detailAll.Eff_Level[0].names.length - 1
                                ]
                              }}&ensp;&ensp;</span
                            ></span
                          >
                        </div>
                        <div class="field">
                          <span class="header"> 法规类别：</span
                          ><span class="con" v-if="detailAll.Reg_Category"
                            ><span
                              >{{
                                detailAll.Reg_Category[0].names[
                                  detailAll.Reg_Category[0].names.length - 1
                                ]
                              }}&ensp;&ensp;</span
                            ></span
                          >
                        </div>

                        <!-- <p>
                  <span v-if="detailAll.Pub_Department">
                    <h5
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: right;
                      "
                    >
                      发布部门：
                    </h5>
                    <h5
                      style="display: inline-block"
                      v-for="(item, index) in detailAll.Pub_Department.names"
                      :key="index"
                    >
                      {{ item }}&ensp;;&ensp;
                    </h5></span
                  >
                </p>
                <p>
                  <span
                    ><h5
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: right;
                      "
                    >
                      发文字号：
                    </h5>
                    {{ detailAll.Iss_Num }}</span
                  >
                </p>
                <span
                  ><h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    发布日期：
                  </h5>
                  {{ detailAll.Pub_Time }}</span
                >
                <span
                  ><h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    实施日期：
                  </h5>
                  {{ detailAll.Pub_Time }}</span
                >
                    <span
                  ><h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    时效性：
                  </h5>
                  {{ detailAll.Timeliness }}</span
                >
                <span v-if="detailAll.Thematic_Class">
                  <h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    专题类型：
                  </h5>
                  <h5
                    style="display: inline-block"
                    v-for="(item, index) in detailAll.Thematic_Class.names"
                    :key="index"
                  >
                    {{ item }}&ensp;;&ensp;
                  </h5></span
                >
                <span v-if="detailAll.Eff_Level"
                  ><h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    效力级别：
                  </h5>
                  <h5
                    style="display: inline-block"
                    v-for="(item, index) in detailAll.Eff_Level.names"
                    :key="index"
                  >
                    {{ item }}&ensp;;&ensp;
                  </h5></span
                >
                <span v-if="detailAll.Reg_Category"
                  ><h5
                    style="
                      display: inline-block;
                      width: 75px;
                      text-align: right;
                    "
                  >
                    法规类别：
                  </h5>
                  <h5
                    style="display: inline-block"
                    v-for="(item, index) in detailAll.Reg_Category.names"
                    :key="index"
                  >
                    {{ item }}&ensp;;&ensp;
                  </h5></span
                > -->
                      </div>
                    </div>
                    <div
                      class="txt"
                      id="item00"
                      v-if="detailAll.type == '法律文书'"
                    >
                      <div class="content01">
                        <div class="field">
                          <span class="header">文书类型：</span
                          ><span class="con" v-if="detailAll.Doc_Category">{{
                            detailAll.Doc_Category.path
                          }}</span>
                        </div>
                        <div class="field">
                          <span class="header">发布部门：</span
                          ><span class="con" v-if="detailAll.Pub_Department"
                            ><span
                              >{{
                                detailAll.Pub_Department.names[
                                  detailAll.Pub_Department.names.length - 1
                                ]
                              }}&ensp;;&ensp;</span
                            ></span
                          >
                        </div>

                        <div class="field">
                          <span class="header">发布日期：</span
                          ><span class="con">{{ detailAll.Pub_Time }}</span>
                        </div>

                        <div class="field">
                          <span class="header"> 时效性：</span
                          ><span class="con">{{ detailAll.Timeliness }}</span>
                        </div>
                        <div class="field_line">
                          <span class="header">发文名称：</span
                          ><span class="con">{{ detailAll.Doc_Name }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="txt" v-if="detailAll.type == '法律文书'">
                      <div
                        class="content"
                        style="
                          line-height: 30px;
                          white-space: pre-wrap;
                          background: white;
                        "
                        v-html="detailAll.Content"
                      ></div>
                    </div>
                    <div
                      class="txt"
                      v-if="
                        detailAll.type == '中央法规' ||
                        detailAll.type == '地方法规'
                      "
                    >
                      <div v-if="detailAll.mulu" style="">
                        <div class="imgTop">
                          <img
                            style=""
                            src="../../../../assets/imgs/2.0/返回顶部、置顶.png"
                            alt=""
                            @click="backTop"
                            v-if="showBtn && detailAll.mulu.length !== 0"
                            class="goTop"
                          />
                        </div>

                        <!-- <el-button
                  type="warning"
                  icon="el-icon-top"
                  circle
                  @click="backTop"
                  v-if="showBtn"
                  class="goTop"
                >
                <img style="width:10px;" src="../../../../assets/imgs/2.0/返回顶部、置顶.png" alt=""></el-button> -->
                      </div>
                      <div
                        class="change-title"
                        v-if="detailAll.law_changes.length > 0"
                      >
                        <span
                          style="
                            padding-left: 10px;
                            font-size: 18px;
                            font-weight: 600;
                            border-left: 3px solid #fad60c;
                          "
                          >本法变迁</span
                        ><span v-if="upOr" @click="packUp"
                          >展开 <i class="el-icon-arrow-down"></i
                        ></span>
                        <span v-if="!upOr" @click="packUp"
                          >收起 <i class="el-icon-arrow-up"></i
                        ></span>
                      </div>
                      <div
                        class="change"
                        v-if="!upOr && detailAll.law_changes.length > 0"
                      >
                        <i class="el-icon-timer c-time"></i>
                        <ul>
                          <li
                            v-for="(item, index) in detailAll.law_changes"
                            :key="index"
                          >
                            <span class="time">{{ item.Pub_Time }}</span>
                            <div class="theme current">
                              <i class="c-dot"></i>
                              <div
                                class="hov"
                                v-for="(item_id, index) in item.data"
                                :key="index"
                              >
                                <router-link
                                  :to="{
                                    path: `/lawsDetail/${item_id._id}`,
                                  }"
                                  target="_blank"
                                  :class="
                                    item_id.Title == detailAll.Title
                                      ? 'one'
                                      : ''
                                  "
                                  ><span :class="index == 0 ? '' : 'two'">{{
                                    item_id.Title
                                  }}</span></router-link
                                >
                              </div>
                            </div>
                            <div></div>
                          </li>
                        </ul>
                      </div>

                      <!-- <div class="change-title"><span>引用本法</span><span v-if="upOr01" @click="packUp01">收起 <i class="el-icon-arrow-up"></i></span>
                <span  v-if="!upOr01" @click="packUp01">展开 <i class="el-icon-arrow-down"></i></span></div>
                <div class="change" v-if="!upOr01">
                  <div>
                    <span v-for="(item, index) in detailAll.law_yin"
                      :key="index"></span>
                  </div>
                </div> -->
                      <div class="txt01">
                        <h2>文书正文</h2>

                        <div v-if="detailAll.Content">
                          <!-- <el-button-group>
                      <el-button size="mini" round class="btn" type="warning"
                        >A<i class="el-icon-minus"></i
                      ></el-button>
                      <el-button class="btn" size="mini" round type="warning"
                        >A<i class="el-icon-plus"></i
                      ></el-button>
                    </el-button-group> -->
                          <div class="font_">
                            字号&emsp;
                            <span @click="increaseFontSize"> A+ </span>
                            &ensp;
                            <span @click="decreaseFontSize"> A- </span>
                          </div>
                          <el-button
                            type="warning"
                            round
                            @click="copyAll"
                            class="btn"
                            data-clipboard-target="#text"
                            data-clipboard-action="copy"
                            size="mini"
                            style="margin: 0px 10px"
                            >复制全文</el-button
                          >
                        </div>
                      </div>
                      <div
                        class="content"
                        id="text"
                        :style="{ fontSize: fontSize + 'px' }"
                        style="
                          line-height: 30px;
                          white-space: pre-wrap;
                          background: white;
                        "
                        v-html="detailAll.Content"
                      ></div>
                      <!-- <div id="aaaaa" style="width: 100%; height: 1500px"></div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="width: 100%;height: 1500px;"></div> -->
      </div>
    </div>

    <ComFooter></ComFooter>
  </div>
</template>

<script>
import store from "@/store";
import $ from "jquery";
import ComFooter from "../../../../components/ComFooter.vue";
import Clipboard from "clipboard"; //引入安装复制插件

export default {
  data() {
    return {
      parameter: {
        id: this.$route.params.id,
        keyword: this.$route.query.keyword,
        type: this.$route.query.radio,
      },
      detailAll: "",
      showBtn: false,
      pageheight: 100,
      upOr: false,
      upOr01: false,
      detailAll00: "",
      text: "",
      muluOne: -1,
      upOrmu: true,
      Height: 0,
      fontSize: 16,
    };
  },
  created() {
    // console.log();
    this.getDetail();
    // if (this.$route.query.tkx) {
    //   var anchor = document.getElementById(this.$route.query.tkx);
    //   anchor.scrollIntoView(true);
    // }

    // if(this.$route.query.tkx){
    //   $("html, body").animate({ scrollTop: $("#"+this.$route.query.tkx).offset().top - 81 });
    // }
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
    window.addEventListener("scroll", this.handleScroll, true);
    this.Height = document.documentElement.clientHeight - 140; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 140;
    };
    var that = this;
    // setTimeout(function () {
    //    that.handleScroll01();
    //   //  grid.api.reloadData();
    // },1000);
    //
  },
  methods: {
     increaseFontSize() {
      if (this.fontSize < 32) {
        this.fontSize += 2; // 增加字体大小 2px
      }
    },
    decreaseFontSize() {
      if (this.fontSize > 8) {
        this.fontSize -= 2; // 减小字体大小 2px
      }
    },
    handleScroll01() {
      // document.getElementById(this.$route.query.tkx).scrollIntoView(true);
      console.log("#" + this.$route.query.tkx);
      // if ($()) {
      //   $("html, body").animate({
      //     scrollTop: $("#" + this.$route.query.tkx).offset().top - 81,
      //   });
      // }
      console.log(
        $("body,html").animate({ scrollTop: $("#T_207").offset().top })
      );
      if ($("#" + this.$route.query.tkx) && this.$route.query.tkx) {
        return;
      }
    },
    handleScroll() {
      // console.log('滚动高度', window.pageYOffset)
      this.pageheight = window.pageYOffset + 100;
      // console.log('距离顶部高度', this.$refs.backTop.getBoundingClientRect().top)
    },
    getDetail() {
      this.$http
        .post("/regdetail", this.parameter)
        .then((res) => {
          // console.log(res);
          this.detailAll00 = res.data.data.list.hits[0];
          this.detailAll = res.data.data.list.hits[0]._source;
          let location = /name="/g;
          let a = this.detailAll.Content.replace(location, 'id="');
          this.detailAll.Content = a;
          // console.log(this.detailAll.Content);
          this.text = this.detailAll.Content;
          // this.handleScroll01();JSON.parse(JSON.stringify(demoGraph));
          // var p = window.document.getElementById(this.$route.query.tkx).parentNode;
          // console.log(p);
          // if (!window.sessionStorage.getItem("anchor")) {
          //   this.detailAll.Content = this.detailAll.Content.replace(
          //     '<div ><a id="'+
          //     this.$route.query.tkx,
          //     '<div style="color:#fad60c;"><a id="'+
          //     this.$route.query.tkx
          //   );
          // }
          //  console.log(this.detailAll.Content);

          // $("#T_1_K_1").parents("div").css("cssText","color:red !important;");
          // console.log(this.detailAll.Content);
          // return
          if (!window.sessionStorage.getItem("anchor")) {
            var that = this;
            setTimeout(function () {
              $("#" + that.$route.query.tkx)
                .parent("div")
                .css("cssText", "color:#fad60c !important;");
              $("body,html").animate(
                { scrollTop: $("#" + that.$route.query.tkx).offset().top - 50 },
                1000
              );
              window.sessionStorage.setItem("anchor", 1);
              //  grid.api.reloadData();
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    jump(position, i) {
      // console.log(position.name);
      // console.log(position.id);
      let id = "#" + position.id;
      $("html, body").animate({ scrollTop: $(id).offset().top - 81 });
      // this.detailAll.Content;
      let textcopy = this.text;
      let ids = textcopy.split(position.id + '"></a>' + position.name);
      ids.splice(
        1,
        0,
        position.id +
          '"></a>' +
          '<span style="color: #409eff;">' +
          position.name +
          "</span>"
      );
      // console.log(ids);
      this.muluOne = i;
      this.detailAll.Content = ids.join("");
    },
    collectible(it) {
      // console.log(it);
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it._id,
          // role: store.getCookie("role"),
          doctype: 3,
          docname: it._source.Title,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: it._id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    packUpmu() {
      this.upOrmu = !this.upOrmu;
    },
    // 单篇下载
    down(id, type) {
      // console.log(id, type);
      if (type == "word") {
        this.$http
          .get("/law/word?id=" + id, {})
          .then((res) => {
            // console.log(res);
            // window.open(res.data.data.url, "_blank");
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (type == "pdf") {
        this.$http
          .get("/law/pdf?id=" + id, {})
          .then((res) => {
            // console.log(res);
            // window.open(res.data.data.url, "_blank");
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 展示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (scrollTop > 750) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
    /*回到顶部实现过程注解：
                1.获取当前页面距离顶部的距离
                2.计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是一个减法
                3.用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
                4.最后在移动到顶部的时候，清除定时器*/
    backTop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    packUp() {
      this.upOr = !this.upOr;
    },
    packUp01() {
      this.upOr01 = !this.upOr01;
    },
    // 复制全文
    copyAll() {
      let textUrl = new Clipboard(".btn");
      textUrl.on("success", (e) => {
        // console.log(e.action);
        this.$message({
          message: "复制成功",
          type: "success",
        });
        textUrl.destroy();
      });
      textUrl.on("error", () => {
        consold.log("没有复制成功");
        this.$message("没有复制成功");
        textUrl.destroy();
      });
      //创建一个 Input标签
      // let oInput = document.createElement("input");
      // oInput.value = this.detailAll.Content;
      // document.body.appendChild(oInput);
      // oInput.select(); // 选择对象;
      // console.log(oInput.value);
      // // 执行浏览器复制命令
      // /// 复制命令会将当前选中的内容复制到剪切板中
      // /// 如这里构建的 Input标签
      // document.execCommand("Copy");
      // this.$message({
      //   message: "复制成功",
      //   type: "success",
      // });
      // ///复制成功后再将构造的标签 移除
      // oInput.remove();
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style  lang='less' scoped>
.lawsDetail {
  background: rgb(245, 239, 228);
}
.lawsDetail_ {
  background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  background-repeat: no-repeat;
  .box {
    width: 85%;
    margin: auto;
  }
  .box00 {
    position: relative;
    width: 100%;

    //
    // width: 85%;
    // background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    // background-size: 100% 50%;
    background-repeat: no-repeat;
  }
  .detail {
    width: 100%;
    // width: 1080px;
    margin: auto;
    .breadcrumb {
      margin: 20px 0 20px 45px;
      height: 36px;
      line-height: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .title {
      background: #ffffff;
      margin-left: 36px;
      padding: 10px;
      // border-radius: 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      // width: 100%;

      h1 {
        width: 100%;
        font-size: 21px;
        font-weight: 600;
        line-height: 60px;
        text-align: center !important;
        // margin-bottom: 20px;
        display: inline-block;
        //
      }
      p {
        margin-bottom: 10px;
        span {
          margin-right: 30px;
          // font-family: ;
        }
      }
    }
    .box_botton {
      .box_body {
        margin-left: 36px;
        background: #ffffff;

        .txt {
          padding-bottom: 10px;
          padding-top: 10px;
          margin-bottom: 20px;
          h2 {
            padding-left: 10px;

            font-size: 18px;
            font-weight: 600;
            border-left: 3px solid #fad60c;
          }
          .content {
            border-radius: 10px;
            background: #f8f7f6;
            margin: 20px;
            padding: 10px 30px;
            font-size: 16px;
            span {
              width: 50%;
              display: inline-block;
              height: 36px;
              line-height: 36px;
            }
          }
        }
      }
    }
  }
}
.txt01 {
  display: flex;
  justify-content: space-between;
  h2 {
    display: inline-block;
    padding-left: 10px;
    font-size: 18px;
    font-weight: 600;
    border-left: 3px solid #fad60c;
    line-height: 30px;
  }
}
.content01 {
  border-radius: 10px;
  background: #f8f7f6;
  margin: 20px;
  padding: 10px 30px;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  div {
    line-height: 30px;
  }
  .field_line {
    width: 100%;
  }
  .field {
    width: 50%;
  }
  .field_line,
  .field {
    .header {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    .cont {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
.directory {
  // margin: 0 20px;
  padding: 0px 0 0 10px;
  // min-height: 50px;
  // font-size: 16px;

  .tit {
    width: 250px;
    display: flex;
    justify-content: space-between;
    padding: 0 0px 0 0;
    // text-align: center;
    line-height: 10px;
    font-size: 20px;
    margin-bottom: 5px;
    // background: #e7e7e7;
    // color: #409eff;
    span {
      display: inline-block;
    }
  }
  ul {
    li {
      line-height: 20px;
      color: #409eff;
      // color: #b3d8ff;
      span {
        width: 180px;
        display: inline-block;
        text-indent: -4em;
        margin-left: 4em;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
      }
      span:hover {
        cursor: pointer;
        color: #b3d8ff;
      }
    }
  }
}
.goTop {
  width: 30px;
  position: fixed;
  bottom: 50px;
  // right: 12%;
  right: calc(50vw - 660px);
  cursor: pointer;
}
.imgTop:hover img {
  content: url("../../../../assets/imgs/2.0/返回顶部、置顶 (1).png");
}
.catalog::-webkit-scrollbar {
  display: none;
}
.catalog01::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}
.catalog01::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 2px;
  background-color: rgb(187, 187, 187);
}
.catalog01::-webkit-scrollbar-track {
  //轨道部分
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 2px;
}
.catalog01 {
  // width: 300px;
  //
  width: 250px;
  max-height: 230px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.catalog {
  // width: 300px;
  // min-height: 50px;
  width: 265px;
  z-index: 100;
  max-height: 300px;
  background: rgb(255, 255, 255);
  // z-index: 100;
  padding: 20px 0;
  border-radius: 10px;
  // overflow-x: hidden;
  // overflow-y: scroll;
  position: fixed;
  top: 160px;
  // left: 100px;
  left: calc(50vw - 650px);
}
.catalogCopy {
  width: 265px;
  z-index: 100;
  max-height: 50px;
  background: rgb(255, 255, 255);

  padding: 20px 0;
  border-radius: 10px;
  position: fixed;
  top: 160px;
  // left: 100px;
  // left: calc(50vw - 730px);
  left: calc(50vw - 650px);
}
.change-title {
  display: flex;
  justify-content: space-between;
  span {
    display: inline-block;
    cursor: pointer;
  }
  font-size: 16px;
  color: #333;
  background: #f7f7f7;
  line-height: 38px;
  padding: 0 20px 0 0;
  margin: 10px 20px 10px 0;
}
.change {
  padding: 10px 30px;
  position: relative;
  ul {
    margin-left: 90px;
    border-left: 1px solid #c9c9c9;
    padding: 20px 20px 10px 20px;
    margin-top: 20px;
    li {
      line-height: 26px;
      margin-bottom: 20px;
      position: relative;
      .time {
        font-size: 12px;
        color: #666;
        position: absolute;
        left: -110px;
        .theme {
          font-size: 14px;
          color: #218fc4;
          font-weight: bold;
          position: relative;
        }
      }
    }
  }
}
.c-time {
  width: 30px;
  height: 30px;
  font-size: 21px;
  background-position: -342px -694px;
  color: #409eff;
  position: absolute;
  top: 20px;
  left: 111px;
}
.c-dot {
  width: 16px;
  height: 16px;
  background: rgb(39, 173, 250);
  background-position: -342px -728px;
  border: 3px solid #fff;
  border-radius: 50%;
  position: absolute;
  left: -29px;
  top: 2px;
}
.two {
  color: rgb(189, 189, 189);
  font-size: 12px;
}
.hov :hover {
  color: #218fc4;
  font-weight: 600;
}
.one {
  color: #218fc4 !important;
  font-weight: 900 !important;
}
.operates {
  display: flex;
  justify-content: flex-end;
}
.collection {
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../../assets/imgs/2.0/收藏3.png");
}
.down_icon {
  width: 20px;
  position: relative;
  top: 3px;
}
.font_ {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  padding: 0px 15px;
  color: #fff;
  background-color: #e6a23c;
  border-color: #e6a23c;
  font-size: 12px;
  border-radius: 15px;
  // span{
  //   display: inline-block;
  //   width: 30px;
  //   text-align: center;
  // }
  span:hover {
    cursor: pointer;
    // font-size: 15px;
    color: #000000;
  }
}
</style>